/* Greg Puzzles shop assistant widget.
   Floating bubble, site-wide. Sends browsing context so the reply differs for
   someone who just arrived versus someone on their sixth product.
   Fails silently: if the API is unreachable the bubble hides itself. */
(function () {
  "use strict";

  var API = "https://ask.gregpuzzles.com";
  var NAME = "Mimi";                 // assistant persona - change here only
  var TITLE = "Chat with " + NAME;
  var THINK_MIN_MS = 5000;          // Greg: show it thinking for at least 5s
  var SEEN_KEY = "gp_seen_products";
  var CID_KEY = "gp_assistant_cid";

  // ---- the nudge ----------------------------------------------------------
  // A bare chat icon gets ignored. This is the prompt that asks for the click.
  // EDIT THE COPY HERE - one line per page type, "_default" covers the rest.
  // No cart entry: the widget does not load on /cart at all (see above).
  var NUDGE_COPY = {
    product:    "Is this one right for you?",
    collection: "Not sure which to pick?",
    article:    "Any questions? Ask me anything",
    _default:   "Any questions? Puzzle help, 24/7"
  };
  var NUDGE_DELAY_MS = 6000;    // let the page settle before asking
  var NUDGE_AUTOHIDE_MS = 15000; // then retire it - it sits over page content
  var NUDGE_HIDE_DAYS = 7;      // how long dismissing with the x sticks
  var NUDGE_KEY = "gp_nudge_off_until";
  var NUDGE_SEEN = "gp_nudge_seen";  // once per session, not once per page

  // ---- live for everyone --------------------------------------------------
  // Kill switches, in order of speed:
  //   1. ssh puzzle-brain "systemctl stop puzzle-assistant"  -> the health check
  //      below fails and the bubble removes itself from every page within seconds.
  //   2. ?assistant=0 -> hides it for one person (this browser) only.
  var params = new URLSearchParams(location.search);
  if (params.get("assistant") === "0") localStorage.setItem("gp_assistant_off", "1");
  if (params.get("assistant") === "1") localStorage.removeItem("gp_assistant_off");
  if (localStorage.getItem("gp_assistant_off") === "1") return;
  //   3. the cart. Greg's call: nothing of hers floats over a purchase in
  //      progress, so the widget is never built on /cart at all.
  if (/^\/cart(\/|$)/.test(location.pathname)) return;

  // ---- browsing context ---------------------------------------------------
  function seen() {
    try { return JSON.parse(sessionStorage.getItem(SEEN_KEY) || "[]"); } catch (e) { return []; }
  }
  function remember(handle) {
    var s = seen();
    if (s.indexOf(handle) === -1) { s.push(handle); sessionStorage.setItem(SEEN_KEY, JSON.stringify(s.slice(-20))); }
  }
  function pageInfo() {
    var p = location.pathname, m;
    if ((m = p.match(/\/products\/([a-z0-9-]+)/))) { remember(m[1]); return { page: "product", handle: m[1] }; }
    if ((m = p.match(/\/collections\/([a-z0-9-]+)/))) return { page: "collection", handle: m[1] };
    if ((m = p.match(/\/blogs\/[a-z0-9-]+\/([a-z0-9-]+)/))) return { page: "article", handle: m[1] };
    if (/\/cart/.test(p)) return { page: "cart" };
    if (p === "/" || p === "") return { page: "home" };
    return { page: "other" };
  }
  function context() {
    var c = pageInfo();
    c.viewed_products = seen();
    var n = document.querySelector("[data-cart-count], .cart-count-bubble span");
    if (n) { var v = parseInt((n.textContent || "").trim(), 10); if (v) c.cart_count = v; }
    return c;
  }

  // ---- ui -----------------------------------------------------------------
  var root = document.createElement("div");
  root.className = "gpa";
  root.innerHTML =
    '<button class="gpa__bubble" type="button" aria-label="Chat with the puzzle assistant">' +
      '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" focusable="false">' +
      '<path fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" ' +
      'stroke-linejoin="round" d="M20.5 11.5a7.5 7.5 0 0 1-10.9 6.7L4.5 19.5l1.3-4.6A7.5 7.5 0 1 1 20.5 11.5z"/>' +
      '</svg>' +
    '</button>' +
    '<div class="gpa__nudge" hidden>' +
      '<button class="gpa__nudge-msg" type="button"></button>' +
      '<button class="gpa__nudge-x" type="button" aria-label="Dismiss">&times;</button>' +
    '</div>' +
    '<div class="gpa__panel" role="dialog" aria-label="Puzzle assistant" hidden>' +
      '<div class="gpa__head"><span class="gpa__title"></span>' +
        '<button class="gpa__close" aria-label="Close">&times;</button></div>' +
      '<div class="gpa__log"></div>' +
      '<form class="gpa__form"><input class="gpa__in" type="text" autocomplete="off" ' +
        'placeholder="Ask me anything about puzzles" maxlength="400"><button class="gpa__send" aria-label="Send">&rarr;</button></form>' +
    '</div>';
  // Start hidden. The health check below is the only thing that reveals her,
  // so a page never paints the bubble before we know the service is up.
  root.style.display = "none";
  document.body.appendChild(root);

  root.querySelector(".gpa__title").textContent = TITLE;

  var bubble = root.querySelector(".gpa__bubble"),
      nudge = root.querySelector(".gpa__nudge"),
      panel = root.querySelector(".gpa__panel"),
      log = root.querySelector(".gpa__log"),
      form = root.querySelector(".gpa__form"),
      input = root.querySelector(".gpa__in");

  function scroll() { log.scrollTop = log.scrollHeight; }

  function add(cls, html) {
    var d = document.createElement("div");
    d.className = "gpa__msg gpa__msg--" + cls;
    d.innerHTML = html;
    log.appendChild(d); scroll();
    return d;
  }

  // WhatsApp-style dots
  function dots() {
    return add("bot gpa__typing", '<span class="gpa__dot"></span><span class="gpa__dot"></span><span class="gpa__dot"></span>');
  }

  function esc(t) {
    return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  // turn any product named in passing into an inline link (no card)
  function linkify(text, mentions, cid) {
    var html = esc(text);
    (mentions || []).forEach(function (m) {
      var t = esc(m.title);
      if (html.indexOf(t) === -1) return;
      html = html.replace(t,
        '<a class="gpa__inline" href="' + m.url + '" data-h="' + m.handle + '">' + t + "</a>");
    });
    return html;
  }

  // reveal word by word so a long answer can be read as it lands
  function reveal(el, text, mentions, cid, done) {
    el.className = "gpa__msg gpa__msg--bot";
    el.textContent = "";
    var words = text.split(" "), i = 0;
    (function step() {
      el.textContent += (i ? " " : "") + words[i++];
      scroll();
      if (i < words.length) {
        setTimeout(step, 22);
      } else {
        // swap in the linked version once the text has finished landing
        if (mentions && mentions.length) {
          el.innerHTML = linkify(text, mentions, cid);
          Array.prototype.forEach.call(el.querySelectorAll(".gpa__inline"), function (a) {
            a.addEventListener("click", function () {
              try {
                navigator.sendBeacon(API + "/event", new Blob(
                  [JSON.stringify({ conversation_id: cid, type: "click", handle: a.dataset.h, meta: { kind: "inline" } })],
                  { type: "text/plain" }));
              } catch (e) {}
            });
          });
        }
        if (done) done();
      }
    })();
  }

  function cards(list, cid) {
    if (!list || !list.length) return;
    var wrap = document.createElement("div");
    wrap.className = "gpa__cards";
    list.forEach(function (p) {
      var a = document.createElement("a");
      a.className = "gpa__card";
      a.href = p.url;
      var meta = [p.difficulty, p.pieces ? p.pieces + " pieces" : null, p.solve_time]
                   .filter(Boolean).join(" · ");
      a.innerHTML =
        (p.image ? '<img class="gpa__card-img" alt="" loading="lazy" width="56" height="56">' : "") +
        '<span class="gpa__card-body"><span class="gpa__card-t"></span>' +
        '<span class="gpa__card-m"></span></span>';
      if (p.image) a.querySelector(".gpa__card-img").src = p.image;
      a.querySelector(".gpa__card-t").textContent = p.title;
      a.querySelector(".gpa__card-m").textContent = meta;
      a.addEventListener("click", function () {
        try {
          navigator.sendBeacon(API + "/event", new Blob(
            [JSON.stringify({ conversation_id: cid, type: "click", handle: p.handle })],
            { type: "text/plain" }));
        } catch (e) {}
      });
      wrap.appendChild(a);
    });
    log.appendChild(wrap); scroll();
  }

  /* A collection is a direction, not an offer: no image, and it carries how many
     puzzles sit behind the link so the customer can judge whether it is worth the
     click. Shown while she is still narrowing down; never beside a final pick. */
  function collectionCards(list, cid) {
    if (!list || !list.length) return;
    var wrap = document.createElement("div");
    wrap.className = "gpa__cards";
    list.forEach(function (c) {
      var a = document.createElement("a");
      a.className = "gpa__card gpa__card--collection";
      a.href = c.url;
      var meta = [c.count ? c.count + " puzzles" : null, c.difficulty]
                   .filter(Boolean).join(" \u00b7 ");
      a.innerHTML =
        '<span class="gpa__card-body"><span class="gpa__card-t"></span>' +
        '<span class="gpa__card-m"></span></span>';
      a.querySelector(".gpa__card-t").textContent = c.title;
      a.querySelector(".gpa__card-m").textContent = meta;
      a.addEventListener("click", function () {
        try {
          navigator.sendBeacon(API + "/event", new Blob(
            [JSON.stringify({ conversation_id: cid, type: "click", handle: c.handle,
                              meta: { kind: "collection" } })],
            { type: "text/plain" }));
        } catch (e) {}
      });
      wrap.appendChild(a);
    });
    log.appendChild(wrap); scroll();
  }

  var cid = sessionStorage.getItem(CID_KEY) || null, busy = false, tagged = false;

  /* Write the conversation id onto the Shopify cart so it survives to checkout
     and arrives on the order as a note attribute. That is what closes the loop
     from "she recommended it" to "they bought it". Fires once per conversation. */
  function tagCart(id) {
    if (!id || tagged) return;
    tagged = true;
    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { assistant_cid: id } })
      }).catch(function () { tagged = false; });
    } catch (e) { tagged = false; }
  }

  function send(text) {
    if (busy || !text) return;
    busy = true;
    add("me", "").textContent = text;
    var t = dots(), started = Date.now();

    fetch(API + "/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: text, conversation_id: cid, context: context() })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        cid = d.conversation_id || cid;
        if (cid) { sessionStorage.setItem(CID_KEY, cid); tagCart(cid); }
        var wait = Math.max(0, THINK_MIN_MS - (Date.now() - started));
        setTimeout(function () {
          reveal(t, d.reply || "Sorry, I lost that one.", d.mentions, cid, function () {
            cards(d.products, cid); collectionCards(d.collections, cid); busy = false;
          });
        }, wait);
      })
      .catch(function () {
        setTimeout(function () {
          reveal(t, "I cannot reach my brain just now. The product pages have everything you need.", null, cid);
          busy = false;
        }, Math.max(0, THINK_MIN_MS - (Date.now() - started)));
      });
  }

  /* Keep the sheet above the on-screen keyboard. Without this the keyboard
     covers the input and you are typing blind. visualViewport is the only
     reliable signal for this on mobile. */
  function fitToKeyboard() {
    if (panel.hidden || !window.visualViewport) return;
    var vv = window.visualViewport;
    var avail = vv.height - 16;
    if (window.innerWidth <= 600) {
      panel.style.height = Math.max(240, Math.min(avail, window.innerHeight * 0.78)) + "px";
      panel.style.bottom = Math.max(8, (window.innerHeight - vv.height - vv.offsetTop) + 8) + "px";
    }
    scroll();
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", fitToKeyboard);
    window.visualViewport.addEventListener("scroll", fitToKeyboard);
  }

  function focusInput() {
    // must run inside the user gesture or mobile browsers will not raise the
    // keyboard; preventScroll stops the page jumping behind the sheet
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
  }

  bubble.addEventListener("click", function () {
    hideNudge(false);
    var open = !panel.hidden;
    panel.hidden = open;
    root.classList.toggle("gpa--open", !open);
    if (!open) {
      focusInput();
      setTimeout(fitToKeyboard, 60);
      if (!log.children.length) {
        var c = context(), n = (c.viewed_products || []).length;
        var hello = "Hi! I'm " + NAME + ", Greg's online assistant. How can I help you today?";
        if (n >= 5) hello += " Looks like you are weighing a few up, so tell me what you are torn between.";
        else if (c.page === "product") hello += " Happy to tell you anything about this one.";
        add("bot", "").textContent = hello;
      }
    }
  });
  root.querySelector(".gpa__close").addEventListener("click", function () {
    panel.hidden = true;
    root.classList.remove("gpa--open");
    panel.style.height = ""; panel.style.bottom = "";
    input.blur();
  });
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var v = input.value.trim();
    input.value = "";
    send(v);
    focusInput();   // keep the keyboard up for the next message
  });

  // record the product page even if the widget is never opened
  pageInfo();

  // ---- nudge behaviour ----------------------------------------------------
  function nudgeSuppressed() {
    // already talking to her, or dismissed recently
    try {
      if (sessionStorage.getItem(CID_KEY)) return true;
      if (sessionStorage.getItem(NUDGE_SEEN)) return true;
      var until = parseInt(localStorage.getItem(NUDGE_KEY) || "0", 10);
      return until > Date.now();
    } catch (e) { return false; }
  }
  function hideNudge(persist) {
    nudge.hidden = true;
    root.classList.remove("gpa--nudging");
    if (persist) {
      try {
        localStorage.setItem(NUDGE_KEY, String(Date.now() + NUDGE_HIDE_DAYS * 864e5));
      } catch (e) {}
    }
  }
  function showNudge() {
    if (nudgeSuppressed() || !panel.hidden) return;
    var page = pageInfo().page;
    nudge.querySelector(".gpa__nudge-msg").textContent = NUDGE_COPY[page] || NUDGE_COPY._default;
    nudge.hidden = false;
    root.classList.add("gpa--nudging");
    try { sessionStorage.setItem(NUDGE_SEEN, "1"); } catch (e) {}
    // retire it on its own: it overlays page content, including Add to cart
    setTimeout(function () { if (!nudge.hidden) hideNudge(false); }, NUDGE_AUTOHIDE_MS);
  }
  nudge.querySelector(".gpa__nudge-msg").addEventListener("click", function () {
    hideNudge(true);
    bubble.click();          // same path as clicking the launcher
  });
  nudge.querySelector(".gpa__nudge-x").addEventListener("click", function (e) {
    e.stopPropagation();
    hideNudge(true);
  });

  // hide entirely if the service is down; only invite the click once it is up
  fetch(API + "/health")
    .then(function () {
      root.style.display = "";
      setTimeout(showNudge, NUDGE_DELAY_MS);
    })
    .catch(function () { root.remove(); });
})();
